/*eslint-disable*/
import React from 'react'
import PropTypes from 'prop-types'
import {Widths,TableClass} from './constants'

const Table = (props) => {
  return (
    <table className={TableClass}>
      <thead>
      <tr>
        <th width={Widths.contractNo}>Contract #
        </th>
        <th width={Widths.vendor}>Vendor</th>
        <th width={Widths.project}>Project<br/>
          <small>(Open Project)</small></th>
        <th width={Widths.poNo}>PO #<br/>
          <small>(Open PO)</small></th>
        <th width={Widths.poAmount} className="text-center">PO Amount</th>
        <th width={Widths.amount} className="text-center">Contract<br/>Amount</th>
      </tr>
      </thead>
      <tbody>{props.children}</tbody>
    </table>
  )
};

Table.propTypes = {};
Table.defaultProps = {};

export default Table;





// WEBPACK FOOTER //
// ./src/components/TableHead.jsx